import { Swiper, Autoplay, Pagination } from 'swiper/js/swiper.esm.js';

Swiper.use([Autoplay, Pagination])

new Swiper('.js-banner__swiper', {
	slidesPerView: 1,
	spaceBetween: 24,
	autoplay: {
		delay: 4000,
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
});
